import { compose } from 'lodash/fp';
import { connect } from 'react-redux';

import { BreakpointRange, DataTestId, WithBreakpointRangeProps, TextKey } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';
import { SegmentedControl, SegmentedControlItem, withBreakpointRange } from '@optimus-web/core';

import { isBookerEnabled } from '../../data/selectors';
import { changeCustomerValue, handleBookingOwnerChange } from '../../slices';

const BOOKER_ENABLED = 'enabled';
const BOOKER_DISABLED = 'disabled';

const BaseBookerRadio = ({ value, onChange, vertical, ...other }: $TSFixMe) => {
    const handleChange = (e: $TSFixMe, val: $TSFixMe) => {
        onChange(val === BOOKER_ENABLED);
    };

    return (
        <div data-test-id={DataTestId.BookerSelection}>
            <SegmentedControl
                vertical={vertical}
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                value={value ? BOOKER_ENABLED : BOOKER_DISABLED}
                onChange={handleChange}
                {...other}
            >
                <SegmentedControlItem
                    label={<LocalizedText textKey={TextKey.BookerDisabled} />}
                    value={BOOKER_DISABLED}
                />
                <SegmentedControlItem
                    data-test-id={DataTestId.EnableBooker}
                    label={<LocalizedText textKey={TextKey.BookerEnabled} />}
                    value={BOOKER_ENABLED}
                />
            </SegmentedControl>
        </div>
    );
};

export const BookerRadio = compose(
    withBreakpointRange<WithBreakpointRangeProps>,
    connect(
        (state, props) => ({
            // @ts-expect-error $TSFixMeError: Argument of type '{}' is not assignable to parameter of type 'ApplicationState'.
            value: isBookerEnabled(state),
            vertical: props.breakpointRange === BreakpointRange.Phone,
        }),
        (dispatch) => ({
            // onChange: handleBookingOwnerChange,
            onChange: (isBooker: $TSFixMe) => {
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe, { heapService }: $TSFixMe) => void' is not assignable to para...
                dispatch(changeCustomerValue({ key: 'booker', value: isBooker }));
                // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => void' is not assignable to parameter of type 'Action<any>'...
                dispatch(handleBookingOwnerChange());
            },
        })
    )
)(BaseBookerRadio);
